import { render, staticRenderFns } from "./OnboardingUISettings.vue?vue&type=template&id=25f1dfa4&scoped=true&lang=pug"
import script from "./OnboardingUISettings.vue?vue&type=script&lang=ts"
export * from "./OnboardingUISettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f1dfa4",
  null
  
)

export default component.exports